import styles from "../shared-card/card.module.scss";

const Card = ({ children }) => {
  return <div className={styles.cardContainer}>{children}</div>;
};

export default Card;
